export default "__VITE_ASSET__BnjvtbNO__"